import { getSupabaseAdmin } from '../lib/supabase';

/**
 * Supabase Storage에 이미지를 업로드하고 공개 URL을 반환합니다.
 * @param file 업로드할 파일
 * @param folder 저장할 폴더 (예: 'banners', 'products')
 * @returns 업로드된 이미지의 공개 URL
 */
export async function uploadImage(file: File, folder: string = 'banners'): Promise<string> {
  try {
    const supabase = getSupabaseAdmin();

    // 파일 확장자 추출
    const fileExt = file.name.split('.').pop();
    // 고유한 파일명 생성 (타임스탬프 + 랜덤 문자열)
    const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExt}`;
    const filePath = `${folder}/${fileName}`;

    // Supabase Storage에 업로드
    const { data, error } = await supabase.storage
      .from('banner-images') // 버킷 이름
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('Image upload error:', error);
      throw new Error(`이미지 업로드 실패: ${error.message}`);
    }

    // 공개 URL 가져오기
    const { data: { publicUrl } } = supabase.storage
      .from('banner-images')
      .getPublicUrl(filePath);

    return publicUrl;
  } catch (error) {
    console.error('Upload image error:', error);
    throw error;
  }
}

/**
 * Supabase Storage에서 이미지를 삭제합니다.
 * @param imageUrl 삭제할 이미지의 URL
 */
export async function deleteImage(imageUrl: string): Promise<void> {
  try {
    const supabase = getSupabaseAdmin();

    // URL에서 파일 경로 추출
    const url = new URL(imageUrl);
    const pathParts = url.pathname.split('/storage/v1/object/public/banner-images/');
    if (pathParts.length < 2) {
      console.warn('Invalid image URL format:', imageUrl);
      return;
    }

    const filePath = pathParts[1];

    // Supabase Storage에서 삭제
    const { error } = await supabase.storage
      .from('banner-images')
      .remove([filePath]);

    if (error) {
      console.error('Image delete error:', error);
      throw new Error(`이미지 삭제 실패: ${error.message}`);
    }
  } catch (error) {
    console.error('Delete image error:', error);
    // 삭제 실패해도 계속 진행
  }
}
